/**
 * Firebase Configuration
 * Конфигурация Firebase для CRM МояФабрика
 */

import { initializeApp, FirebaseApp } from 'firebase/app';
import { getMessaging, Messaging } from 'firebase/messaging';

// Firebase конфигурация
const firebaseConfig = {
  apiKey: "AIzaSyDhP3tDLjNwH-eBTPw_4ZOEEb7PBvsy3ew",
  authDomain: "myfabric-452b8.firebaseapp.com",
  projectId: "myfabric-452b8",
  storageBucket: "myfabric-452b8.firebasestorage.app",
  messagingSenderId: "416653876747",
  appId: "1:416653876747:web:cc89eb2063e36fc4dc310e"
};

// VAPID ключ для Web Push
export const VAPID_KEY = 'BJqhwiGKRMwIxuZyuc7vN020324q4W6xGYNUv9QT87dFvOeUHLM6aZYVO5Zy4Ve1CuLbDzY0r2erwuo1lQIV_FI';

// Инициализация Firebase
let firebaseApp: FirebaseApp | null = null;
let messaging: Messaging | null = null;

/**
 * Инициализирует Firebase приложение
 */
export function initializeFirebase(): FirebaseApp {
  if (!firebaseApp) {
    firebaseApp = initializeApp(firebaseConfig);
  }
  return firebaseApp;
}

/**
 * Получает экземпляр Firebase Messaging
 */
export function getFirebaseMessaging(): Messaging | null {
  try {
    if (!messaging && typeof window !== 'undefined' && 'serviceWorker' in navigator) {
      const app = initializeFirebase();
      messaging = getMessaging(app);
    }
    return messaging;
  } catch (error) {
    return null;
  }
}

export { firebaseApp, messaging };

